module.exports = __webpack_public_path__ + "static/media/22 - 21 Savage - a lot.20510b98.mp3";